import * as Sentry from '@sentry/react';
import { ServiceError } from '../../utils/httpUtils.js';

const LogSentryMessage = ({ message, level = "info", tags, extra }) => {
    return Sentry.captureMessage(message ? `${message}` : `No message provided`, {
        tags,
        extra,
        level,
    });
};
const LogSentryException = ({ messagePrefix, error, level = "error", tags, extra, }) => {
    const originalMsg = error instanceof Error ? error.message : `${error}`;
    const msg = messagePrefix ? `${messagePrefix}: ${originalMsg}` : `${originalMsg}`;
    let err;
    if (error instanceof Error) {
        // Without this it is copied by reference, and it modifies the original error object
        err = new Error();
        err.message = msg;
        err.cause = error.cause;
        err.name = error.name;
        err.stack = error.stack;
    }
    else {
        err = new Error(msg, { cause: error });
    }
    const additionalExtra = { ...extra };
    if (error instanceof ServiceError) {
        additionalExtra.serviceErrorResponse = error.serviceErrorResponse;
    }
    return Sentry.captureException(err, {
        tags,
        extra: additionalExtra,
        level,
    });
};
/**
 * @deprecated Use LogSentryException instead
 */
const LogSentryEvent = LogSentryException;

export { LogSentryEvent, LogSentryException, LogSentryMessage };
//# sourceMappingURL=sentryLogger.js.map
